/* ============================================================
   Collection redesign controller — extracted from the inline
   <script> blocks in snippets/collection-grid.liquid,
   snippets/collection-grid-filters-form.liquid and
   sections/main-collection.liquid so the HTML payload shrinks
   and the code is fetched once and browser-cached (LCP).
   Loaded with defer from snippets/collection-grid.liquid, so it
   is present on both the collection and search templates.
   Liquid-injected value: window.__collectionSliderParam (set by
   an inline one-liner in sections/main-collection.liquid).
   ============================================================ */


/* Pin the scroll position across the next AJAX collection render.
   Hardened against two failure modes found by the T3 audit:
   (a) AjaxRenderer's fetch chain has no .catch, so a network failure means
       collection:reloaded never fires — the failsafe timeout restores
       updateScroll (without scrolling) so it can't stay stubbed forever;
   (b) overlapping interactions used to capture each other's no-op stub as
       the "original" — the TRUE original is captured once per instance on
       __origUpdateScroll and always restored from there. */
function pinScrollForNextReload(inst) {
  var y = window.scrollY;
  if (!inst.__origUpdateScroll) inst.__origUpdateScroll = inst.updateScroll;
  inst.updateScroll = function () {};
  var done = false;
  function restore(scroll) {
    if (done) return;
    done = true;
    clearTimeout(failsafe);
    document.removeEventListener('collection:reloaded', onReloaded);
    inst.updateScroll = inst.__origUpdateScroll;
    if (scroll) window.scrollTo(0, y);
  }
  function onReloaded() { restore(true); }
  var failsafe = setTimeout(function () { restore(false); }, 8000);
  document.addEventListener('collection:reloaded', onReloaded);
}


/* Build the mobile drawer's facet form CLIENT-SIDE from the desktop
   sidebar's server-rendered copy (heavy-page render fix): the form used
   to render twice per request, and on big-catalog pages the doubled
   facet-value loops exceeded Shopify's Liquid resource limit (hard 500).
   The clone: strips the sidebar header, rewrites every
   CollectionSidebar-suffixed id/for/aria-controls/data-collapsible-id/
   name to SidebarDrawer (sort radios MUST be renamed or the two radio
   groups would uncheck each other), collapses every facet (drawer
   default), and rebinds theme.collapsibles on the new nodes (the theme
   binds triggers per-element, so clones start unbound). Idempotent via
   data-populated; re-run after full AJAX swaps and editor reloads. */
function populateFilterDrawer() {
  var drawer = document.getElementById('FilterDrawer');
  if (!drawer) return;
  var target = drawer.querySelector('[data-drawer-form-target]');
  if (!target || target.dataset.populated === 'true') return;
  var source = document.querySelector('#CollectionSidebar .collection-sidebar');
  if (!source) return;
  var frag = document.createDocumentFragment();
  Array.prototype.forEach.call(source.children, function (child) {
    if (child.classList && child.classList.contains('collection-sidebar__header')) return;
    frag.appendChild(child.cloneNode(true));
  });
  var attrs = ['id', 'for', 'aria-controls', 'data-collapsible-id', 'name'];
  frag.querySelectorAll('*').forEach(function (el) {
    attrs.forEach(function (a) {
      var v = el.getAttribute(a);
      if (v && v.indexOf('CollectionSidebar') !== -1) {
        el.setAttribute(a, v.split('CollectionSidebar').join('SidebarDrawer'));
      }
    });
    if (el.classList.contains('collapsible-trigger')) {
      el.classList.remove('is-open');
      el.setAttribute('aria-expanded', 'false');
    }
    if (el.classList.contains('collapsible-content')) {
      el.classList.remove('is-open');
      el.style.height = '';
    }
  });
  target.appendChild(frag);
  target.dataset.populated = 'true';
  if (window.theme && theme.collapsibles && theme.collapsibles.init) {
    theme.collapsibles.init(target);
  }
}

/* ── From snippets/collection-grid.liquid ── */
  (function() {
    function cleanupFilterScroll() {
      if (typeof window.__collectionFilterScrollCleanup === 'function') {
        window.__collectionFilterScrollCleanup();
        window.__collectionFilterScrollCleanup = null;
      }
    }

    function initFilterScroll() {
      cleanupFilterScroll();

      var filter = document.querySelector('.collection-filter');
      var sentinel = document.querySelector('.collection-filter-sentinel');
      var header = document.querySelector('.site-header');
      if (!filter || !sentinel) return;

      var lastY = window.scrollY;
      var isStuck = false;
      var isHidden = false;
      var ticking = false;
      var DEADZONE = 5;

      /* The bar's sticky top must track the HEADER'S scroll state, not a
         fixed 59px: theme.js only fixes .site-header after scrollY > 250,
         so on pages where the bar reaches its pin point sooner (no hero,
         short tab block) a headerHeight top pinned the bar 59px below the
         viewport top with a white band above it (Andrew: "big space
         between the toolbar and the header"). Header off-screen -> pin at
         0; header fixed -> pin flush under it. theme.js's
         setFilterStickyPosition writes the same state-aware value, so the
         two writers always agree. Returns the applied top so the caller
         never re-reads the just-written property (a getComputedStyle
         straight after the write forced a synchronous reflow). */
      /* The pinned region banner (snippets/region-banner.liquid) sits fixed
         above everything and pushes the stuck header down by its height via
         --region-banner-height — every sticky top below the header stacks
         on the same offset (banner → header → bar), and reads 0 once the
         banner is dismissed or absent. */
      function bannerOffset() {
        return parseFloat(getComputedStyle(document.documentElement)
          .getPropertyValue('--region-banner-height')) || 0;
      }

      function syncStickyTop() {
        var wantTop = bannerOffset() + (header && header.classList.contains('site-header--stuck')
          ? header.offsetHeight
          : 0);
        var wantTopPx = wantTop + 'px';
        if (filter.style.top !== wantTopPx) filter.style.top = wantTopPx;
        return wantTop;
      }

      /* Desktop: the tab bar pins under the STUCK header and the sidebar
         under the stuck tab bar. theme.js's setFilterStickyPosition used
         to DERIVE the stuck header height from its at-rest height minus a
         padding delta — correct for the old header, wrong the moment the
         header's structure changes (the new nav's taller header left the
         tab bar overlapping it). Measure instead: whenever the header's
         stuck state flips, read its ACTUAL rendered offsetHeight in that
         state and write the tops from it. State-gated, so this costs one
         measurement per flip, not per frame. */
      var lastDesktopStuck = null;
      function syncDesktopTops() {
        if (window.innerWidth < 769 || !header) return;
        // Banner height is part of the state key: the region banner pushes
        // the stuck header down, so its appearance/dismissal must re-write
        // the tops even when the header's stuck state hasn't flipped —
        // the stack is banner → header → tab bar → sidebar.
        var bannerH = bannerOffset();
        var stuck = header.classList.contains('site-header--stuck') + ':' + bannerH;
        if (stuck === lastDesktopStuck) return;
        lastDesktopStuck = stuck;
        var headerH = bannerH + header.offsetHeight;
        var tabBar = document.querySelector('.category-slider');
        var sidebar = document.querySelector('.grid__item--sidebar');
        var tabH = tabBar ? tabBar.offsetHeight : 0;
        if (tabBar) tabBar.style.top = headerH + 'px';
        if (sidebar) {
          var sidebarTop = headerH + tabH;
          sidebar.style.top = sidebarTop + 'px';
          sidebar.style.maxHeight = 'calc(100vh - ' + sidebarTop + 'px)';
        }
      }

      function syncStickyState() {
        syncDesktopTops();
        if (window.innerWidth >= 769) {
          isStuck = false;
          isHidden = false;
          filter.classList.remove('collection-filter--stuck', 'collection-filter--hidden');
          return false;
        }

        var stickyTop = syncStickyTop();
        var nextIsStuck = sentinel.getBoundingClientRect().top <= stickyTop;

        if (nextIsStuck) {
          filter.classList.add('collection-filter--stuck');
        } else {
          filter.classList.remove('collection-filter--stuck', 'collection-filter--hidden');
          isHidden = false;
        }

        isStuck = nextIsStuck;
        return nextIsStuck;
      }

      /* Track scroll direction */
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function() {
          var currentY = window.scrollY;
          var delta = currentY - lastY;
          var nextIsStuck = syncStickyState();

          if (nextIsStuck) {
            if (delta > DEADZONE && !isHidden) {
              /* Scrolling down — slide bar up out of view */
              filter.classList.add('collection-filter--hidden');
              isHidden = true;
            } else if (delta < -DEADZONE && isHidden) {
              /* Scrolling up — slide bar back down */
              filter.classList.remove('collection-filter--hidden');
              isHidden = false;
            }
          }

          lastY = currentY;
          ticking = false;
        });
      }

      function onResize() {
        /* theme.js's debounced resize handler rewrites the tops with its
           derived values; force a fresh measurement on the next sync so
           the measured values win again. */
        lastDesktopStuck = null;
        syncStickyState();
      }

      syncStickyState();
      requestAnimationFrame(syncStickyState);

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);

      window.__collectionFilterScrollCleanup = function() {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
      };
    }

    /* Run on DOM ready */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFilterScroll, { once: true });
    } else {
      initFilterScroll();
    }

    /* Re-run after AJAX collection reload */
    if (!window.__collectionFilterReloadBound) {
      document.addEventListener('collection:reloaded', function() {
        requestAnimationFrame(initFilterScroll);
      });
      window.__collectionFilterReloadBound = true;
    }

    /* Theme editor section re-render */
    document.addEventListener('shopify:section:load', initFilterScroll);
  })();

  /* ── Grid Column Toggle (mobile: 1/2/3) ── */
  (function () {
    var STORAGE_KEY = 'impulse_grid_cols';

    function applyColumns(cols, animate) {
      var btns = document.querySelectorAll('.js-grid-col-btn');
      var wrapper = document.querySelector('.collection-grid__wrapper');
      if (!wrapper) return;
      btns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-columns') === cols;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      });
      wrapper.setAttribute('data-mobile-columns', cols);
      if (animate) {
        wrapper.classList.remove('cols-animating');
        void wrapper.offsetWidth;
        wrapper.classList.add('cols-animating');
        setTimeout(function () { wrapper.classList.remove('cols-animating'); }, 500);
      }
    }

    function applySaved() {
      var saved = sessionStorage.getItem(STORAGE_KEY) || '2';
      applyColumns(saved, false);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-grid-col-btn');
      if (!btn) return;
      var cols = btn.getAttribute('data-columns');
      applyColumns(cols, true);
      sessionStorage.setItem(STORAGE_KEY, cols);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (window.AOS) { AOS.refreshHard(); }
        });
      });
    });

    document.addEventListener('collection:reloaded', applySaved);
    document.addEventListener('shopify:section:load', applySaved);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applySaved);
    } else {
      applySaved();
    }
  })();

  /* ── Desktop Grid Column Toggle (4/5/7) ── */
  (function () {
    var STORAGE_KEY = 'impulse_grid_cols_desktop';
    var DEFAULT_COLS = '5';

    function applyDesktopColumns(cols, animate) {
      var btns = document.querySelectorAll('.js-grid-col-btn-desktop');
      var wrapper = document.querySelector('.collection-grid__wrapper');
      if (!wrapper) return;
      btns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-columns') === cols;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      });
      wrapper.setAttribute('data-desktop-columns', cols);
      if (animate) {
        wrapper.classList.remove('cols-animating-desktop');
        void wrapper.offsetWidth;
        wrapper.classList.add('cols-animating-desktop');
        setTimeout(function () { wrapper.classList.remove('cols-animating-desktop'); }, 500);
      }
    }

    function applySaved() {
      var saved = sessionStorage.getItem(STORAGE_KEY) || DEFAULT_COLS;
      applyDesktopColumns(saved, false);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-grid-col-btn-desktop');
      if (!btn) return;
      var cols = btn.getAttribute('data-columns');
      applyDesktopColumns(cols, true);
      sessionStorage.setItem(STORAGE_KEY, cols);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (window.AOS) { AOS.refreshHard(); }
        });
      });
    });

    document.addEventListener('collection:reloaded', applySaved);
    document.addEventListener('shopify:section:load', applySaved);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applySaved);
    } else {
      applySaved();
    }
  })();

  /* ── Dynamic Product Count ── */
  (function () {
    function updateCount() {
      var countEls = document.querySelectorAll('[data-collection-count]');
      if (!countEls.length) return;
      // Prefer the true total from the infinite-scroll feed; counting DOM
      // cards only sees the loaded page(s), so it under-reports (e.g. 28).
      var feed = document.querySelector('[data-infinite-scroll-feed]');
      var total = feed ? parseInt(feed.getAttribute('data-total-products'), 10) : NaN;
      var n = (!isNaN(total) && total > 0)
        ? total
        : document.querySelectorAll('.collection-grid__wrapper .grid-product').length;
      var text = n + ' product' + (n !== 1 ? 's' : '');
      countEls.forEach(function (el) { el.textContent = text; });
    }

    document.addEventListener('collection:reloaded', updateCount);
    document.addEventListener('shopify:section:load', updateCount);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateCount);
    } else {
      updateCount();
    }
  })();

/* ── From snippets/collection-grid-filters-form.liquid ── */
  (function() {
    // Guard: only register the delegated listeners once across AJAX reloads
    if (window.__filterChipsInit) return;
    window.__filterChipsInit = true;

    // ── Mobile drawer: single facet open at a time ──
    // The theme's collapsible allows multiple facets open. In the mobile
    // filter drawer only one should be open at once. We can't just .click()
    // the others closed — theme.collapsibles has an isTransitioning guard
    // that would then block the user's open. Instead close the others
    // manually (direct height transition) in the CAPTURE phase, before the
    // theme's bubble-phase toggle opens the tapped facet.
    function closeDrawerFacet(trigger) {
      var id = trigger.getAttribute('aria-controls');
      var content = id ? document.getElementById(id) : null;
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (!content) return;
      var inner = content.querySelector('.collapsible-content__inner');
      // auto -> fixed px -> 0 so the CSS height transition actually runs
      content.style.height = (inner ? inner.offsetHeight : content.offsetHeight) + 'px';
      void content.offsetHeight; // force reflow
      content.classList.remove('is-open');
      content.style.height = '0px';
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.collapsible-trigger');
      if (!trigger) return;
      var drawer = document.getElementById('FilterDrawer');
      if (!drawer || !drawer.contains(trigger)) return;
      // Only when this facet is about to OPEN (currently closed).
      if (trigger.classList.contains('is-open')) return;
      drawer.querySelectorAll('.collapsible-trigger.is-open').forEach(function (other) {
        if (other !== trigger) closeDrawerFacet(other);
      });
    }, true);

    // ── Mobile drawer: DEFERRED filter apply ──
    // Ticking options in the drawer must NOT auto-apply (the desktop
    // sidebar keeps instant apply). The theme binds an 'input' listener on
    // each .filter-form that fires the AJAX render — stop the event in the
    // CAPTURE phase at document level (runs before the form's bubble
    // handler) for inputs inside the drawer. We take over the .tag--active
    // visual state the theme handler owned (the drawer title is static
    // "Filter & Sort" — the live count lives on the SHOW button instead).
    // Everything applies at once when SHOW is tapped (handler below).

    // SHOW (n) ⇄ Clear (x): a PRISTINE drawer (no interaction since it
    // was opened / since the last apply) with filters applied reads
    // "Clear (x)" (x = applied filter values in the URL); the moment the
    // user touches anything in the drawer it flips to "Show (n)" (n =
    // currently ticked options; plain "Show" at zero). Dirty-flag based,
    // NOT a params-equality check: the drawer DOM persists across swaps,
    // and any URL param without a matching form input (active tab param,
    // skipped facet) made equality misjudge the state — ticking a third
    // filter read "Clear (3)". The click handler below reads data-mode;
    // Liquid renders the initial state server-side.
    var drawerDirty = false;
    function updateDrawerApplyButton() {
      var drawer = document.getElementById('FilterDrawer');
      if (!drawer) return;
      var btn = drawer.querySelector('.js-apply-drawer-filters');
      if (!btn) return;
      var applied = 0;
      new URLSearchParams(window.location.search).forEach(function (_, k) {
        if (k.indexOf('filter.') === 0) applied++;
      });
      if (!drawerDirty && applied > 0) {
        btn.textContent = 'Clear (' + applied + ')';
        btn.dataset.mode = 'clear';
      } else {
        var ticked = drawer.querySelectorAll('.filter-form .tag__input:checked').length;
        btn.textContent = 'Show' + (ticked > 0 ? ' (' + ticked + ')' : '');
        btn.dataset.mode = 'show';
      }
    }
    // The button recomputes at exactly TWO moments (Andrew): when the
    // drawer is OPENED (pristine: Clear (x) if the URL has filters, Show
    // otherwise) and when the user interacts inside it (dirty: Show (n)).
    // Deliberately NOT hooked to collection:reloaded — that event fires
    // from background renders (infinite-scroll page loads, reinits) and
    // was resetting the state mid-session: the "flicker to Clear" bug.
    // Capture phase: the theme's own drawer-open handler is a document
    // capture listener that calls stopPropagation() — a bubble listener
    // here would never fire. Same-target capture listeners all run
    // regardless of stopPropagation, so this always sees the open.
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('.js-drawer-open-collection-filters')) {
        populateFilterDrawer(); // no-op when already built
        drawerDirty = false;
        updateDrawerApplyButton();
      }
    }, true);

    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input.closest) return;
      var form = input.closest('.filter-form');
      if (!form) return;

      // Both surfaces bypass the theme's form handler (its isAnimating gate
      // swallows rapid clicks, and it smooth-scrolls the page pre-render).
      e.stopPropagation();

      if (input.type === 'radio') {
        form.querySelectorAll('.tag__input[name="' + CSS.escape(input.name) + '"]').forEach(function (other) {
          var otherLi = other.closest('li.tag');
          if (otherLi) otherLi.classList.remove('tag--active');
        });
      }
      var li = input.closest('li.tag');
      if (li) li.classList.toggle('tag--active', input.checked);

      var drawer = document.getElementById('FilterDrawer');
      if (drawer && drawer.contains(input)) {
        // Mobile drawer: deferred — applies on close. Prefetch NOW so the
        // close is a synchronous cache hit.
        drawerDirty = true;
        updateDrawerApplyButton();
        prefetchSection(computeDrawerParams());
        return;
      }

      // Desktop sidebar: apply immediately, every click. Rapid clicks are
      // safe — AjaxRenderer's latest-wins sequencing discards superseded
      // in-flight renders, so only the final state ever paints.
      var params = new URLSearchParams(new FormData(form));
      params.delete('page');
      var inst = getCollectionInstance();
      if (!inst) return;
      inst.setFilterDrawerState();
      inst.startLoading();
      inst.renderCollectionPage(params);
    }, true);

    // ── Perceived-instant filtering: prefetch section renders ──
    // AjaxRenderer keeps a URL-keyed cache (cachedSections) that renderPage
    // checks BEFORE fetching. Prefetching the exact section URL into that
    // cache turns the eventual apply into a synchronous render with no
    // network wait. Desktop prefetches on hover (hover precedes the click
    // by hundreds of ms); the drawer prefetches on tick (apply happens
    // later, on close).
    var prefetchInFlight = {};
    function prefetchSection(newParams) {
      if (!newParams) return;
      var inst = getCollectionInstance();
      if (!inst || !inst.ajaxRenderer) return;
      var renderer = inst.ajaxRenderer;
      // Reuse the renderer's own param merge so the URL string is
      // byte-identical to the one renderPage will look up.
      var updated = renderer.getUpdatedParams(new URLSearchParams(window.location.search), newParams);
      renderer.sections.forEach(function (section) {
        var url = window.location.pathname + '?section_id=' + section.sectionId + '&' + updated.toString();
        if (prefetchInFlight[url]) return;
        if (renderer.cachedSections.some(function (c) { return c.url === url; })) return;
        prefetchInFlight[url] = true;
        fetch(url)
          .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(r.status)); })
          .then(function (html) {
            delete prefetchInFlight[url]; // in-flight marker only; dedupe is cachedSections
            // cap what prefetching can grow the cache to
            if (renderer.cachedSections.length > 30) renderer.cachedSections.shift();
            renderer.cachedSections.push({ html: html, url: url });
            // Warm the image cache for the first rows of the would-be grid
            // so the eventual swap paints from cache instead of popping in.
            // srcset+sizes are copied so the browser fetches the exact same
            // candidate the real <img> will select.
            try {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var imgs = doc.querySelectorAll('.collection-product-grid img');
              for (var i = 0; i < imgs.length && i < 15; i++) {
                var warm = new Image();
                var sizes = imgs[i].getAttribute('sizes');
                var srcset = imgs[i].getAttribute('srcset');
                if (sizes) warm.sizes = sizes;
                if (srcset) warm.srcset = srcset;
                var src = imgs[i].getAttribute('src');
                if (src) warm.src = src;
              }
            } catch (e) { /* warm-up is best-effort */ }
          })
          .catch(function () { delete prefetchInFlight[url]; });
      });
    }

    // What the URL params WOULD be if this (desktop sidebar) checkbox were
    // toggled — mirrors what onFormSubmit will build from FormData after
    // the click actually lands.
    function paramsAfterToggle(input) {
      var form = input.closest('form');
      if (!form) return null;
      if (input.type === 'radio' && input.checked) return null;
      var params = new URLSearchParams(new FormData(form));
      var others = input.type === 'radio' ? [] : params.getAll(input.name).filter(function (v) { return v !== input.value; });
      params.delete(input.name);
      others.forEach(function (v) { params.append(input.name, v); });
      if (!input.checked) params.append(input.name, input.value);
      params.delete('page');
      return params;
    }

    function paramsForSort(radio) {
      var wrapper = radio.closest('.collection-sidebar__group--sort');
      var def = wrapper ? wrapper.dataset.defaultSort : '';
      var params = new URLSearchParams(window.location.search);
      params.delete('sort_by');
      if (radio.value !== def) params.set('sort_by', radio.value);
      params.delete('page');
      return params;
    }

    // Desktop: prefetch when the pointer reaches an option, before the
    // click. No per-element "already prefetched" flag: the sidebar DOM now
    // PERSISTS across applies (grid-only swaps), so a flag would go stale —
    // after an apply, the same label's toggled-URL is different and needs a
    // fresh prefetch. Dedupe lives in prefetchSection (by URL), which makes
    // repeat hovers over unchanged state free.
    // Bound to #CollectionSidebar, not document, so the closest() walks
    // don't run for every pointerover across the whole page (grid hovers
    // especially). The dataset flag survives grid-only swaps (the sidebar
    // element persists); if a full swap ever replaces the element, the
    // collection:reloaded rebind picks the fresh one up.
    function onSidebarPointerOver(e) {
      if (!e.target.closest) return;
      var label = e.target.closest('.collection-sidebar .tag__checkbox-wrapper, .collection-sidebar .sort-radio__label');
      if (!label) return;
      var input = label.querySelector('.tag__input');
      if (input) { prefetchSection(paramsAfterToggle(input)); return; }
      var radio = label.querySelector('.sort-radio__input');
      if (radio && !radio.checked) prefetchSection(paramsForSort(radio));
    }
    function bindSidebarPrefetchHover() {
      var sidebar = document.getElementById('CollectionSidebar');
      if (!sidebar || sidebar.dataset.prefetchHoverBound === 'true') return;
      sidebar.dataset.prefetchHoverBound = 'true';
      sidebar.addEventListener('pointerover', onSidebarPointerOver);
    }
    bindSidebarPrefetchHover();
    document.addEventListener('collection:reloaded', bindSidebarPrefetchHover);

    // Applying: the drawer's pending selections fire on ANY close — SHOW
    // RESULTS, the X, click-outside, ESC (Andrew: apply on all of them).
    // All close paths funnel through theme.Drawers.prototype.close, so one
    // hook covers them; a params-equality check makes it a no-op when
    // nothing changed (incl. the close() calls the theme fires during
    // section init/reinit).
    function computeDrawerParams() {
      var drawer = document.getElementById('FilterDrawer');
      if (!drawer) return null;
      var form = drawer.querySelector('.filter-form');
      var params = new URLSearchParams(form ? new FormData(form) : '');
      // Sort radios live outside the form
      var sortRadio = drawer.querySelector('.sort-radio__input:checked');
      var sortWrapper = sortRadio && sortRadio.closest('.collection-sidebar__group--sort');
      var defaultSort = sortWrapper ? sortWrapper.dataset.defaultSort : '';
      params.delete('sort_by');
      if (sortRadio && sortRadio.value !== defaultSort) params.set('sort_by', sortRadio.value);
      params.delete('page');
      return params;
    }

    function drawerParamsPending() {
      var params = computeDrawerParams();
      if (params === null) return null;
      // Current URL, reduced to the keys the drawer controls
      var current = new URLSearchParams(window.location.search);
      var relevant = new URLSearchParams();
      current.forEach(function (v, k) {
        if (k.indexOf('filter.') === 0 || k === 'sort_by') relevant.append(k, v);
      });
      var a = params.toString().split('&').sort().join('&');
      var b = relevant.toString().split('&').sort().join('&');
      return a === b ? null : params;
    }

    var applyingDrawerFilters = false;
    function applyDrawerSelections() {
      if (applyingDrawerFilters) return;
      var params = drawerParamsPending();
      if (!params) return; // nothing changed
      // Search pages: the filter form doesn't carry q/type (they live in the
      // URL, not the form), so fold them in before rendering — otherwise the
      // AJAX render would drop the query. getUpdatedParams treats q/type as
      // preserved+replace, so passing them here can't stack them.
      var isSearchPage = window.location.pathname.indexOf('/search') === 0;
      if (isSearchPage) {
        var currentSearch = new URLSearchParams(window.location.search);
        var q = currentSearch.get('q');
        if (q) params.set('q', q);
        var searchType = currentSearch.get('type');
        if (searchType) params.set('type', searchType);
      }
      var search = params.toString() ? '?' + params.toString() : '';
      // AJAX on search pages too (was full navigation): route through the live
      // grid instance, falling back to full navigation only if none exists.
      var collectionInstance = getCollectionInstance() || (window.theme && theme.activeCollectionGrid);
      if (!collectionInstance) {
        window.location.href = window.location.pathname + search;
        return;
      }
      applyingDrawerFilters = true;
      document.addEventListener('collection:reloaded', function done() {
        document.removeEventListener('collection:reloaded', done);
        applyingDrawerFilters = false;
      });
      history.replaceState({}, '', window.location.pathname + search);
      collectionInstance.setFilterDrawerState(); // drawer closed → no persist, full re-render
      collectionInstance.startLoading();
      collectionInstance.renderCollectionPage(params);
    }

    // Hook every close path (X, overlay click, ESC, SHOW RESULTS). Lazy:
    // this inline script can parse before theme.js defines theme.Drawers,
    // so retry on each click (no-ops via the flag once patched) — any
    // close is necessarily preceded by a click, so the hook is always in
    // place before the first close.
    function ensureDrawerCloseHook() {
      if (!window.theme || !theme.Drawers || !theme.Drawers.prototype) return;
      if (theme.Drawers.prototype.__filterApplyPatched) return;
      theme.Drawers.prototype.__filterApplyPatched = true;
      var __origDrawerClose = theme.Drawers.prototype.close;
      theme.Drawers.prototype.close = function () {
        // Only a close that actually CLOSED the drawer applies selections:
        // wasOpen filters the theme's programmatic close() calls during
        // section init/reinit (drawer already closed), and !this.isOpen
        // afterwards filters the GUARDED no-op calls — the theme's
        // outside-click handler invokes close(evt) for every page click,
        // including clicks INSIDE the open drawer (ticking a checkbox!),
        // and relies on early-return guards to keep it open. Applying on
        // those no-ops made every drawer tick apply instantly (T10 fail).
        var wasOpen = this.isOpen;
        var result = __origDrawerClose.apply(this, arguments);
        if (wasOpen && !this.isOpen && this.config && this.config.id === 'FilterDrawer') applyDrawerSelections();
        return result;
      };
    }
    ensureDrawerCloseHook();
    document.addEventListener('click', ensureDrawerCloseHook, true);

    // ── Deferred fetch overlay ──
    // Hooked centrally on renderCollectionPage so every filter path gets
    // it. A 250ms timer arms on each render; only if it fires before the
    // render completes does the grid get the .is-fetching dim + spinner
    // (old results stay visible, grid-scoped, non-blocking elsewhere).
    // Fast responses — prefetch cache hits especially — land first and
    // cancel it, so they never flash an overlay. Lazy patch, same reason
    // as the drawer close hook.
    function ensureDeferredOverlayHook() {
      if (!window.theme || !theme.Collection || !theme.Collection.prototype) return;
      if (theme.Collection.prototype.__deferredOverlayPatched) return;
      theme.Collection.prototype.__deferredOverlayPatched = true;

      var overlayTimer = null;
      var overlayFailsafe = null;
      function clearFetchOverlay() {
        if (overlayTimer) { clearTimeout(overlayTimer); overlayTimer = null; }
        if (overlayFailsafe) { clearTimeout(overlayFailsafe); overlayFailsafe = null; }
        var w = document.querySelector('.collection-grid__wrapper');
        if (w) w.classList.remove('is-fetching');
      }

      // Grid images within two viewports that haven't finished loading.
      // Far-below-fold lazy images are excluded (they only load on scroll,
      // so waiting on them would hold the overlay forever), as are
      // zero-size/invisible images (hover-reveal variants etc. — some
      // never load, and would stall the sweep into the failsafe).
      function pendingVisibleGridImages() {
        var grid = document.querySelector('.collection-product-grid');
        if (!grid) return [];
        var vh = window.innerHeight;
        var pending = [];
        grid.querySelectorAll('img').forEach(function (img) {
          var r = img.getBoundingClientRect();
          if (r.width === 0 || r.height === 0) return;
          if (r.bottom < -100 || r.top > vh * 2) return;
          if (img.complete && img.naturalWidth > 0) return;
          pending.push(img);
        });
        return pending;
      }

      // The render issue only ARMS the overlay; release is driven entirely
      // by 'collection:painted' below. No per-render completion listeners:
      // those stacked, and a superseded render finishing fired ALL of them
      // — the newest render's release check then ran against the OLD DOM
      // (everything complete), cleared the overlay, and the real paint
      // landed cold afterwards. That was the pop-in-with-no-overlay bug.
      var __origRenderCollectionPage = theme.Collection.prototype.renderCollectionPage;
      theme.Collection.prototype.renderCollectionPage = function (searchParams, updateURLHash) {
        if (overlayTimer) clearTimeout(overlayTimer);
        overlayTimer = setTimeout(function () {
          overlayTimer = null;
          var w = document.querySelector('.collection-grid__wrapper');
          if (w) w.classList.add('is-fetching');
        }, 250);
        // Last-resort clear (e.g. fetch rejects and no paint ever fires) —
        // a permanently dimmed grid is the one thing worse than a late
        // image.
        if (overlayFailsafe) clearTimeout(overlayFailsafe);
        overlayFailsafe = setTimeout(clearFetchOverlay, 25000);
        return __origRenderCollectionPage.call(this, searchParams, updateURLHash);
      };

      // Single persistent release path, keyed to ACTUAL paints (the
      // 'collection:painted' event fires only when a swap really happened
      // — stale renders never dispatch it). Belt-and-braces: the paint is
      // already image-gated pre-swap (AjaxRenderer decodes the first rows
      // before painting), so this sweep is normally clean on its first
      // pass; it only holds the overlay for stragglers beyond the gated
      // set, and re-sweeps until a pass finds nothing loading.
      var sweepToken = 0;
      document.addEventListener('collection:painted', function () {
        var token = ++sweepToken;

        function sweep() {
          if (token !== sweepToken) return; // superseded by a newer paint
          var pending = pendingVisibleGridImages();
          if (!pending.length) { clearFetchOverlay(); return; }

          // Something visible is still loading — hold the overlay now.
          if (overlayTimer) { clearTimeout(overlayTimer); overlayTimer = null; }
          var wrapper = document.querySelector('.collection-grid__wrapper');
          if (wrapper) wrapper.classList.add('is-fetching');

          var remaining = pending.length;
          pending.forEach(function (img) {
            var onLoadOrError = function () {
              img.removeEventListener('load', onLoadOrError);
              img.removeEventListener('error', onLoadOrError);
              remaining--;
              if (remaining <= 0) requestAnimationFrame(sweep);
            };
            img.addEventListener('load', onLoadOrError);
            img.addEventListener('error', onLoadOrError);
          });
        }
        sweep();
      });
    }
    ensureDeferredOverlayHook();
    document.addEventListener('click', ensureDeferredOverlayHook, true);

    // SHOW RESULTS / Clear (x) — mode-aware (see updateDrawerApplyButton).
    // Show mode: just close; the close hook applies the selections.
    // Clear mode: untick everything, reset sort to default, and apply the
    // cleared state immediately — the drawer stays open (grid-only swap
    // keeps its DOM alive) and the button flips back to SHOW RESULTS.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-apply-drawer-filters');
      if (!btn) return;
      if (btn.dataset.mode === 'clear') {
        var drawer = document.getElementById('FilterDrawer');
        if (drawer) {
          drawer.querySelectorAll('.filter-form .tag__input:checked').forEach(function (input) {
            input.checked = false;
            var li = input.closest('li.tag');
            if (li) li.classList.remove('tag--active');
          });
          var sortWrapper = drawer.querySelector('.collection-sidebar__group--sort');
          if (sortWrapper) {
            var defaultSort = sortWrapper.dataset.defaultSort;
            sortWrapper.querySelectorAll('.sort-radio__input').forEach(function (r) {
              r.checked = r.value === defaultSort;
            });
          }
          // Availability back to default (Show): drop the form's hidden
          // mirrors and reset the toggle's own inputs/buttons.
          var availGroup = drawer.querySelector('.js-availability-toggle-group');
          if (availGroup) {
            availGroup.querySelectorAll('.availability-toggle__input').forEach(function (inp) {
              drawer.querySelectorAll('.filter-form input[type="hidden"][name="' + inp.name + '"]').forEach(function (m) { m.remove(); });
              inp.checked = false;
            });
            availGroup.querySelectorAll('.availability-toggle__btn').forEach(function (b) {
              var active = b.dataset.availAction === 'show';
              b.classList.toggle('availability-toggle__btn--active', active);
              b.setAttribute('aria-pressed', String(active));
            });
          }
        }
        applyDrawerSelections();
        // Clearing leaves the drawer pristine (its state IS the applied
        // state) — replaceState in applyDrawerSelections has already
        // synced the URL, so this lands on plain "Show".
        drawerDirty = false;
        updateDrawerApplyButton();
        return;
      }
      if (window.theme && theme.FilterDrawer) {
        theme.FilterDrawer.close();
      } else {
        applyDrawerSelections();
      }
    });

    function getCollectionInstance() {
      return theme.sections && theme.sections.instances &&
        theme.sections.instances.find(function(inst) {
          return inst.type === 'collection-grid';
        });
    }

    // Save drawer scroll position and restore after collection:reloaded.
    // onReplaceAjaxContent sets existingScrollable.innerHTML which resets scrollTop.
    function preserveDrawerScroll() {
      var drawer = document.getElementById('FilterDrawer');
      var scrollable = drawer && drawer.querySelector('.drawer__scrollable');
      var saved = scrollable ? scrollable.scrollTop : 0;
      if (saved === 0) return;
      document.addEventListener('collection:reloaded', function restore() {
        document.removeEventListener('collection:reloaded', restore);
        var d = document.getElementById('FilterDrawer');
        var s = d && d.querySelector('.drawer__scrollable');
        if (s) s.scrollTop = saved;
      });
    }

    // Intercept filter chip removal and CLEAR ALL — keep filter drawer open
    document.addEventListener('click', function(e) {
      var chip = e.target.closest('.filter-chip__link');
      var clearAll = !chip && e.target.closest('.filter-chips-clear-all');
      var link = chip || clearAll;
      if (!link) return;

      e.preventDefault();

      // AJAX on search pages too (was full navigation): the chip/clear-all
      // href already carries q, so renderCollectionPage(newUrl.searchParams)
      // preserves the query. Fall back to full nav only if no grid instance.
      var collectionInstance = getCollectionInstance() || (window.theme && theme.activeCollectionGrid);
      if (!collectionInstance) {
        window.location.href = link.href;
        return;
      }

      var newUrl = new URL(link.href);

      // Sync URL before renderCollectionPage reads window.location.search.
      // getUpdatedParams has a mutation-during-iteration bug: clone.delete(key)
      // during for...of clone.entries() shifts remaining entries, so every other
      // filter key is skipped when newParams is empty (CLEAR ALL case).
      // By replaceState-ing first, currentParams already matches the target,
      // so getUpdatedParams has nothing to delete and the bug is bypassed.
      history.replaceState({}, '', newUrl.pathname + (newUrl.search || ''));

      collectionInstance.setFilterDrawerState();
      if (!collectionInstance.shouldReopenFilterDrawer) {
        pinScrollForNextReload(collectionInstance);
      }
      preserveDrawerScroll();
      collectionInstance.startLoading();
      collectionInstance.renderCollectionPage(newUrl.searchParams);
    });

    // Sort By radio — AJAX update, keep drawer open.
    // Selecting the default sort removes sort_by from the URL (no non-default sort active)
    // so the filter button count correctly stays at 0 for that selection.
    document.addEventListener('change', function(e) {
      var radio = e.target.closest('.sort-radio__input');
      if (!radio) return;

      // Drawer sort is deferred — selection is picked up on drawer close,
      // no AJAX here (desktop sidebar keeps instant apply below). Prefetch
      // the would-be render so the close is a cache hit.
      if (radio.closest('#FilterDrawer')) {
        drawerDirty = true;
        updateDrawerApplyButton();
        prefetchSection(computeDrawerParams());
        return;
      }

      var sortWrapper = radio.closest('.collection-sidebar__group--sort');
      var defaultSort = sortWrapper ? sortWrapper.dataset.defaultSort : '';

      var params = new URLSearchParams(window.location.search);

      if (radio.value === defaultSort) {
        params.delete('sort_by');
      } else {
        params.set('sort_by', radio.value);
      }
      params.delete('page');

      // AJAX on search pages too (was full navigation): params is built from
      // window.location.search so it already carries q/type; route through the
      // live grid instance and fall back to full navigation only if none exists.
      var newSearch = params.toString() ? '?' + params.toString() : '';
      var collectionInstance = getCollectionInstance() || (window.theme && theme.activeCollectionGrid);
      if (!collectionInstance) {
        window.location.href = window.location.pathname + newSearch;
        return;
      }

      // Sync URL before renderCollectionPage reads window.location.search,
      // so getUpdatedParams sees the correct sort_by and doesn't double-append.
      history.replaceState({}, '', window.location.pathname + newSearch);

      collectionInstance.setFilterDrawerState();
      if (!collectionInstance.shouldReopenFilterDrawer) collectionInstance.updateScroll(true);
      preserveDrawerScroll();
      collectionInstance.startLoading();
      collectionInstance.renderCollectionPage(params);
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.availability-toggle__btn');
      if (!btn) return;

      var group = btn.closest('.js-availability-toggle-group');
      if (!group) return;

      var action = btn.dataset.availAction;
      var allBtns = group.querySelectorAll('.availability-toggle__btn');
      var inputs = group.querySelectorAll('.availability-toggle__input');

      var collectionInstance = getCollectionInstance();
      if (!collectionInstance) return;

      // Optimistically update button states
      allBtns.forEach(function(b) {
        var active = b === btn;
        b.classList.toggle('availability-toggle__btn--active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      // Get the availability param name from the hidden input
      var paramName = inputs.length > 0 ? inputs[0].name : 'filter.v.availability';

      // Mobile drawer: deferred like every other drawer facet — no AJAX
      // here. The drawer form's hidden availability MIRROR inputs are what
      // FormData/computeDrawerParams read (the toggle's own checkbox
      // inputs live OUTSIDE the form), so rewrite them to the pending
      // choice; apply happens on close, prefetched now.
      var drawerEl = document.getElementById('FilterDrawer');
      if (drawerEl && drawerEl.contains(group)) {
        drawerDirty = true;
        inputs.forEach(function (inp) { inp.checked = action === 'hide'; });
        var drawerForm = drawerEl.querySelector('.filter-form');
        if (drawerForm) {
          drawerForm.querySelectorAll('input[type="hidden"][name="' + paramName + '"]').forEach(function (m) { m.remove(); });
          if (action === 'hide') {
            var mirror = document.createElement('input');
            mirror.type = 'hidden';
            mirror.name = paramName;
            mirror.value = '1';
            drawerForm.appendChild(mirror);
          }
        }
        updateDrawerApplyButton();
        prefetchSection(computeDrawerParams());
        return;
      }

      // Desktop apply — but first sync BOTH form copies' hidden
      // availability mirrors to this choice: the sidebar/drawer DOM
      // persists across grid-only swaps, so a stale Liquid-rendered
      // mirror would silently drop/re-add the availability param on the
      // next FormData-based apply (checkbox click / drawer close).
      document.querySelectorAll('#CollectionSidebar .filter-form').forEach(function (f) {
        f.querySelectorAll('input[type="hidden"][name="' + paramName + '"]').forEach(function (m) { m.remove(); });
        if (action === 'hide') {
          var mirror = document.createElement('input');
          mirror.type = 'hidden';
          mirror.name = paramName;
          mirror.value = '1';
          f.appendChild(mirror);
        }
      });

      // Build params from the current URL — reliable source of all active filters
      var params = new URLSearchParams(window.location.search);
      params.delete(paramName);
      if (action === 'hide') {
        params.append(paramName, '1');
      }

      collectionInstance.setFilterDrawerState();
      if (!collectionInstance.shouldReopenFilterDrawer) collectionInstance.updateScroll(true);
      preserveDrawerScroll();
      collectionInstance.startLoading();
      collectionInstance.renderCollectionPage(params);
    });
    // ── Real-time color swatch chips ──
    // When a swatch checkbox is checked/unchecked inside the drawer, immediately
    // add or remove the corresponding chip in .color-active-swatches on the main
    // page. The AJAX response (collection:reloaded) replaces CollectionAjaxContent
    // with server-rendered chips — so optimistic chips are just a visual bridge.
    document.addEventListener('change', function(e) {
      var input = e.target.closest('.tag--swatch .tag__input');
      if (!input) return;
      // Only act on checkboxes inside the filter drawer
      if (!input.closest('#FilterDrawer')) return;

      var chipsContainer = document.querySelector('.color-active-swatches');
      if (!chipsContainer) return;

      var li = input.closest('li');
      if (!li) return;

      var labelText = li.querySelector('.tag__text');
      var swatchEl = li.querySelector('.color-swatch--filter');
      var paramName = input.name;
      var paramValue = input.value;
      var chipKey = paramName + '=' + paramValue;

      if (input.checked) {
        // Don't duplicate if server-rendered chip already exists
        if (chipsContainer.querySelector('[data-chip-key="' + chipKey + '"]')) return;

        // Compute the url_to_remove equivalent so the existing chip click handler
        // can fire AJAX correctly when the X is clicked.
        var params = new URLSearchParams(window.location.search);
        var existingValues = params.getAll(paramName).filter(function(v) { return v !== paramValue; });
        params.delete(paramName);
        existingValues.forEach(function(v) { params.append(paramName, v); });
        var removeUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');

        var chip = document.createElement('a');
        chip.className = 'filter-chip__link color-active-chip';
        chip.dataset.chipKey = chipKey;
        chip.href = removeUrl;

        var circle = document.createElement('span');
        circle.className = 'color-chip-circle';
        if (swatchEl) {
          // Mirror the inline style from the swatch element in the drawer
          if (swatchEl.style.backgroundImage) {
            circle.style.backgroundImage = swatchEl.style.backgroundImage;
            circle.style.backgroundSize = 'cover';
          } else if (swatchEl.style.backgroundColor) {
            circle.style.backgroundColor = swatchEl.style.backgroundColor;
          }
        }

        var labelEl = document.createElement('span');
        labelEl.className = 'filter-chip__label';
        labelEl.textContent = labelText ? labelText.textContent.trim() : paramValue;

        var xSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        xSvg.setAttribute('class', 'filter-chip__remove');
        xSvg.setAttribute('aria-hidden', 'true');
        xSvg.setAttribute('focusable', 'false');
        xSvg.setAttribute('width', '12');
        xSvg.setAttribute('height', '12');
        xSvg.setAttribute('viewBox', '0 0 12 12');
        xSvg.setAttribute('fill', 'none');
        var xPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        xPath.setAttribute('d', 'M2 2L10 10M10 2L2 10');
        xPath.setAttribute('stroke', '#0a0a0a');
        xPath.setAttribute('stroke-width', '1.2');
        xPath.setAttribute('stroke-linecap', 'round');
        xSvg.appendChild(xPath);

        chip.appendChild(circle);
        chip.appendChild(labelEl);
        chip.appendChild(xSvg);
        chipsContainer.appendChild(chip);
        chipsContainer.classList.remove('color-active-swatches--hidden');

      } else {
        // Remove matching chip immediately
        var existing = chipsContainer.querySelector('[data-chip-key="' + chipKey + '"]');
        if (existing) existing.remove();
        if (chipsContainer.querySelectorAll('.filter-chip__link').length === 0) {
          chipsContainer.classList.add('color-active-swatches--hidden');
        }
      }
    });
  })();

/* ── From sections/main-collection.liquid ── */
  (function () {
    // ── Category Slider ──────────────────────────────────────────
    var ENABLE_TABS_SLIDER_AUTOSCROLL = false;
    var SLIDER_AUTOSCROLL_MAX_LOOPS = 3;
    var SLIDER_PARAM = window.__collectionSliderParam || '';
    var SLIDER_AUTOPLAY_DURATION = 26000;
    var SLIDER_MIN_SPEED_PX_PER_SECOND = 30;
    var SLIDER_RESIZE_DEBOUNCE = 180;
    var SLIDER_DESKTOP_SLIDE_DURATION = 480;
    var sliderAutoplayRaf = null;
    var sliderDesktopSlideRaf = null;
    var sliderRefreshRaf = null;
    var sliderResizeTimer = null;
    var tabImageRequestCache = {};
    var tabImageUrlCache = {};
    var sliderAutoplayState = {
      paused: false,
      hovered: false,
      lastTimestamp: 0,
      offset: 0,
      completedLoops: 0
    };
    var sliderDragState = {
      active: false,
      pointerId: null,
      startX: 0,
      startOffset: 0,
      moved: false,
      suppressClick: false
    };

    function getActiveSliderFilterValue() {
      var params = new URLSearchParams(window.location.search);
      return params.get(SLIDER_PARAM) || '';
    }

    function getCategorySliderElements() {
      var slider = document.querySelector('[data-category-slider]');
      if (!slider) return null;

      var mobileTrack = slider.querySelector('.category-slider__track');
      var desktop = slider.querySelector('[data-category-slider-desktop]');
      var viewport = slider.querySelector('[data-category-slider-viewport]');
      var rail = slider.querySelector('[data-category-slider-rail]');

      return {
        slider: slider,
        mobileTrack: mobileTrack,
        desktop: desktop,
        viewport: viewport,
        rail: rail
      };
    }

    function isDesktopViewport() {
      return window.matchMedia('(min-width: 769px)').matches;
    }

    function getRailBaseMarkup(rail) {
      if (!rail) return '';

      if (typeof rail._baseMarkup !== 'string') {
        rail._baseMarkup = rail.innerHTML;
      }

      return rail._baseMarkup;
    }

    function restoreDesktopRail(rail) {
      if (!rail) return;

      cancelDesktopSlideAnimation();

      var baseMarkup = getRailBaseMarkup(rail);
      if (rail.innerHTML !== baseMarkup) {
        rail.innerHTML = baseMarkup;
      }

      rail.dataset.marqueeReady = 'false';
      rail.dataset.loopWidth = '0';
      rail.dataset.staticMaxOffset = '0';
      rail.style.transform = 'translate3d(0, 0, 0)';
      syncCategoryTabs();
    }

    function getSliderLoopWidth(rail) {
      if (!rail) return 0;

      var loopWidth = parseFloat(rail.dataset.loopWidth || '0');
      return Number.isFinite(loopWidth) ? loopWidth : 0;
    }

    function getStaticScrollMetrics(rail, viewport) {
      if (!viewport) {
        return {
          maxScrollLeft: 0,
          currentScrollLeft: 0
        };
      }

      var contentWidth = Math.max(
        viewport.scrollWidth,
        rail ? rail.scrollWidth : 0
      );
      var maxScrollLeft = Math.max(contentWidth - viewport.clientWidth, 0);
      var currentScrollLeft = Math.max(0, Math.min(viewport.scrollLeft, maxScrollLeft));

      return {
        maxScrollLeft: maxScrollLeft,
        currentScrollLeft: currentScrollLeft
      };
    }

    function getStaticMaxOffset(rail, viewport) {
      return getStaticScrollMetrics(rail, viewport).maxScrollLeft;
    }

    function calculateSequenceWidth(items) {
      if (!items || !items.length) return 0;

      var firstItem = items[0];
      var lastItem = items[items.length - 1];
      return (lastItem.offsetLeft + lastItem.offsetWidth) - firstItem.offsetLeft;
    }

    function cancelSliderRefreshFrame() {
      if (sliderRefreshRaf) {
        cancelAnimationFrame(sliderRefreshRaf);
        sliderRefreshRaf = null;
      }
    }

    function cancelDesktopSlideAnimation() {
      if (sliderDesktopSlideRaf) {
        cancelAnimationFrame(sliderDesktopSlideRaf);
        sliderDesktopSlideRaf = null;
      }
    }

    function animateStaticDesktopOffset(rail, targetOffset, onUpdate) {
      if (!rail) return;

      cancelDesktopSlideAnimation();

      var startOffset = sliderAutoplayState.offset;
      var delta = targetOffset - startOffset;

      if (Math.abs(delta) < 0.5) {
        sliderAutoplayState.offset = targetOffset;
        applyMarqueeOffset(rail, sliderAutoplayState.offset);
        if (typeof onUpdate === 'function') {
          onUpdate();
        }
        return;
      }

      var startTime = 0;

      function tick(timestamp) {
        if (!startTime) {
          startTime = timestamp;
        }

        var progress = Math.min((timestamp - startTime) / SLIDER_DESKTOP_SLIDE_DURATION, 1);
        var easedProgress = progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        sliderAutoplayState.offset = startOffset + (delta * easedProgress);
        applyMarqueeOffset(rail, sliderAutoplayState.offset);

        if (typeof onUpdate === 'function') {
          onUpdate();
        }

        if (progress < 1) {
          sliderDesktopSlideRaf = requestAnimationFrame(tick);
          return;
        }

        sliderAutoplayState.offset = targetOffset;
        applyMarqueeOffset(rail, sliderAutoplayState.offset);

        if (typeof onUpdate === 'function') {
          onUpdate();
        }

        sliderDesktopSlideRaf = null;
      }

      sliderDesktopSlideRaf = requestAnimationFrame(tick);
    }

    function forceSliderLayout(track) {
      if (!track) return;

      void track.offsetWidth;
      void track.scrollWidth;
    }

    function hasMobileTrackOverflow(track) {
      if (!track) return false;

      return (track.scrollWidth - track.clientWidth) > 1;
    }

    function hasDesktopTrackOverflow(rail, viewport) {
      if (!rail || !viewport) return false;

      return (rail.scrollWidth - viewport.clientWidth) > 1;
    }

    function syncSliderLayoutMode() {
      var elements = getCategorySliderElements();
      if (!elements) return;

      var hasOverflow = isDesktopViewport()
        ? hasDesktopTrackOverflow(elements.rail, elements.viewport)
        : hasMobileTrackOverflow(elements.mobileTrack);

      elements.slider.classList.toggle('is-static-layout', !hasOverflow);
    }

    function stopSliderAutoplay(resetState) {
      if (sliderAutoplayRaf) {
        cancelAnimationFrame(sliderAutoplayRaf);
        sliderAutoplayRaf = null;
      }

      var elements = getCategorySliderElements();
      if (elements) {
        elements.slider.classList.remove('is-auto-scrolling');
        elements.slider.classList.remove('is-marquee-active');
      }

      if (resetState) {
        sliderAutoplayState.paused = false;
        sliderAutoplayState.hovered = false;
        sliderAutoplayState.lastTimestamp = 0;
        sliderAutoplayState.offset = 0;
        sliderAutoplayState.completedLoops = 0;
      }
    }

    function syncDesktopCloneAttributes(rail) {
      if (!rail) return;

      rail.querySelectorAll('[data-marquee-clone="true"]').forEach(function (node) {
        node.setAttribute('aria-hidden', 'true');
        node.tabIndex = -1;
        if (node.id) {
          node.removeAttribute('id');
        }
      });
    }

    function setupDesktopMarqueeRail(rail, viewport) {
      if (!rail || !viewport) return;

      restoreDesktopRail(rail);

      if (!isDesktopViewport()) {
        return;
      }

      forceSliderLayout(rail);

      var originalItems = Array.prototype.slice.call(rail.children);
      if (!originalItems.length) {
        return;
      }

      var loopWidth = calculateSequenceWidth(originalItems);
      if (loopWidth <= 0) {
        return;
      }

      var copyCount = Math.max(1, Math.ceil(viewport.clientWidth / loopWidth));
      var cloneFragment = document.createDocumentFragment();

      for (var copyIndex = 0; copyIndex < copyCount; copyIndex++) {
        originalItems.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.dataset.marqueeClone = 'true';
          cloneFragment.appendChild(clone);
        });
      }

      rail.appendChild(cloneFragment);
      syncDesktopCloneAttributes(rail);
      rail.dataset.marqueeReady = 'true';
      rail.dataset.loopWidth = String(loopWidth);
      rail.style.transform = 'translate3d(0, 0, 0)';
    }

    function shouldResumeDesktopAutoplay(viewport, rail) {
      return ENABLE_TABS_SLIDER_AUTOSCROLL &&
        isDesktopViewport() &&
        !sliderAutoplayState.hovered &&
        sliderAutoplayState.completedLoops < SLIDER_AUTOSCROLL_MAX_LOOPS &&
        hasDesktopMarqueeOverflow(rail, viewport);
    }

    function setupStaticDesktopRail(rail, viewport) {
      if (!rail || !viewport) return;

      restoreDesktopRail(rail);

      if (!isDesktopViewport()) {
        return;
      }

      forceSliderLayout(rail);
      forceSliderLayout(viewport);

      var metrics = getStaticScrollMetrics(rail, viewport);
      var maxOffset = metrics.maxScrollLeft;
      var currentOffset = metrics.currentScrollLeft;

      rail.dataset.staticMaxOffset = String(maxOffset);
      rail.style.transform = 'translate3d(0, 0, 0)';
      viewport.scrollLeft = currentOffset;
      sliderAutoplayState.offset = currentOffset;
    }

    function hasDesktopMarqueeOverflow(rail, viewport) {
      var loopWidth = getSliderLoopWidth(rail);
      return !!(rail && viewport && rail.dataset.marqueeReady === 'true' && loopWidth > 0);
    }

    function hasStaticDesktopOverflow(rail, viewport) {
      return !!(rail && viewport && getStaticMaxOffset(rail, viewport) > 1);
    }

    function normalizeMarqueeOffset(offset, loopWidth) {
      if (!loopWidth) return 0;

      offset = offset % loopWidth;
      if (offset < 0) {
        offset += loopWidth;
      }

      return offset;
    }

    function applyMarqueeOffset(rail, offset) {
      if (!rail) return;

      rail.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
    }

    function startDesktopMarquee() {
      var elements = getCategorySliderElements();
      if (!elements) return;

      var slider = elements.slider;
      var viewport = elements.viewport;
      var rail = elements.rail;

      if (!viewport || !rail) return;

      cancelDesktopSlideAnimation();

      if (!ENABLE_TABS_SLIDER_AUTOSCROLL) {
        setupStaticDesktopRail(rail, viewport);
        stopSliderAutoplay(false);
        return;
      }

      stopSliderAutoplay(false);
      setupDesktopMarqueeRail(rail, viewport);
      forceSliderLayout(rail);

      if (!isDesktopViewport() || !hasDesktopMarqueeOverflow(rail, viewport)) {
        slider.classList.remove('is-auto-scrolling');
        slider.classList.remove('is-marquee-active');
        return;
      }

      slider.classList.add('is-auto-scrolling');
      slider.classList.add('is-marquee-active');
      sliderAutoplayState.lastTimestamp = 0;
      sliderAutoplayState.offset = 0;
      sliderAutoplayState.completedLoops = 0;
      applyMarqueeOffset(rail, sliderAutoplayState.offset);

      function tick(timestamp) {
        var currentElements = getCategorySliderElements();
        if (!currentElements) {
          stopSliderAutoplay(true);
          return;
        }

        var currentSlider = currentElements.slider;
        var currentViewport = currentElements.viewport;
        var currentRail = currentElements.rail;

        if (!currentViewport || !currentRail || !hasDesktopMarqueeOverflow(currentRail, currentViewport)) {
          currentSlider.classList.remove('is-auto-scrolling');
          currentSlider.classList.remove('is-marquee-active');
          stopSliderAutoplay(true);
          return;
        }

        if (!sliderAutoplayState.lastTimestamp) {
          sliderAutoplayState.lastTimestamp = timestamp;
        }

        var delta = timestamp - sliderAutoplayState.lastTimestamp;
        sliderAutoplayState.lastTimestamp = timestamp;

        if (!sliderAutoplayState.paused) {
          var loopWidth = getSliderLoopWidth(currentRail);
          if (loopWidth <= 0) {
            stopSliderAutoplay(true);
            return;
          }

          var distancePerMs = Math.max(
            loopWidth / SLIDER_AUTOPLAY_DURATION,
            SLIDER_MIN_SPEED_PX_PER_SECOND / 1000
          );
          var nextOffset = sliderAutoplayState.offset + (distancePerMs * delta);
          var completedLoopsThisTick = Math.floor(nextOffset / loopWidth);
          if (completedLoopsThisTick > 0) {
            sliderAutoplayState.completedLoops += completedLoopsThisTick;
          }

          if (sliderAutoplayState.completedLoops >= SLIDER_AUTOSCROLL_MAX_LOOPS) {
            sliderAutoplayState.paused = true;
            sliderAutoplayState.offset = 0;
            applyMarqueeOffset(currentRail, sliderAutoplayState.offset);
            currentSlider.classList.remove('is-auto-scrolling');
            sliderAutoplayRaf = null;
            return;
          }

          sliderAutoplayState.offset = nextOffset;
          sliderAutoplayState.offset = normalizeMarqueeOffset(sliderAutoplayState.offset, loopWidth);
          applyMarqueeOffset(currentRail, sliderAutoplayState.offset);
        }

        sliderAutoplayRaf = requestAnimationFrame(tick);
      }

      sliderAutoplayRaf = requestAnimationFrame(tick);
    }

    function refreshSliderAutoplay() {
      var elements = getCategorySliderElements();
      if (!elements) return;

      if (isDesktopViewport()) {
        startDesktopMarquee();
      } else {
        cancelDesktopSlideAnimation();
        stopSliderAutoplay(true);
        restoreDesktopRail(elements.rail);
      }

      // Next frame: the branch above just WROTE (rail restore/transform),
      // and syncSliderLayoutMode READS scrollWidth/clientWidth — same-frame
      // that's a forced synchronous layout (traced at 41ms on 4x-throttled
      // mobile in hasMobileTrackOverflow). One frame later the browser has
      // done layout naturally and the reads are free. is-static-layout
      // landing a frame later is CLS-neutral: the 17px inset just moves
      // between the track and the inner wrapper (net-zero geometry).
      requestAnimationFrame(function () {
        syncSliderLayoutMode();
        elements.slider.dispatchEvent(new CustomEvent('category-slider:layout-updated'));
      });
    }

    function scheduleSliderAutoplayRefresh() {
      cancelSliderRefreshFrame();

      sliderRefreshRaf = requestAnimationFrame(function () {
        sliderRefreshRaf = requestAnimationFrame(function () {
          sliderRefreshRaf = null;
          refreshSliderAutoplay();
        });
      });
    }

    function bindSliderAutoplayInteractions() {
      var elements = getCategorySliderElements();
      if (!elements) return;

      var viewport = elements.viewport;
      if (!viewport || viewport.dataset.autoplayBound == 'true') return;

      viewport.dataset.autoplayBound = 'true';

      viewport.addEventListener('mouseenter', function () {
        if (isDesktopViewport()) {
          sliderAutoplayState.hovered = true;
          sliderAutoplayState.paused = true;
        }
      });

      viewport.addEventListener('mouseleave', function () {
        sliderAutoplayState.hovered = false;
        if (shouldResumeDesktopAutoplay(viewport, elements.rail)) {
          sliderAutoplayState.paused = false;
        }
      });
    }

    function bindSliderDragInteractions() {
      var elements = getCategorySliderElements();
      if (!elements) return;

      var slider = elements.slider;
      var viewport = elements.viewport;
      var rail = elements.rail;
      if (!viewport || !rail || viewport.dataset.dragBound == 'true') return;

      viewport.dataset.dragBound = 'true';

      function resetDragState() {
        sliderDragState.active = false;
        sliderDragState.pointerId = null;
        sliderDragState.startX = 0;
        sliderDragState.startOffset = 0;
        sliderDragState.moved = false;
        slider.classList.remove('is-dragging');
      }

      viewport.addEventListener('pointerdown', function (event) {
        if (!isDesktopViewport() || event.pointerType === 'touch' || event.button !== 0) {
          return;
        }

        var canDrag = ENABLE_TABS_SLIDER_AUTOSCROLL
          ? hasDesktopMarqueeOverflow(rail, viewport)
          : false;

        if (!canDrag) {
          return;
        }

        cancelDesktopSlideAnimation();
        sliderAutoplayState.paused = true;
        sliderDragState.active = true;
        sliderDragState.pointerId = event.pointerId;
        sliderDragState.startX = event.clientX;
        sliderDragState.startOffset = sliderAutoplayState.offset;
        sliderDragState.moved = false;
        sliderDragState.suppressClick = false;
      });

      viewport.addEventListener('pointermove', function (event) {
        if (!sliderDragState.active || event.pointerId !== sliderDragState.pointerId || !isDesktopViewport()) {
          return;
        }

        var deltaX = event.clientX - sliderDragState.startX;
        if (Math.abs(deltaX) > 8) {
          if (!sliderDragState.moved) {
            sliderDragState.moved = true;
            sliderDragState.suppressClick = true;
            slider.classList.add('is-dragging');
            if (!viewport.hasPointerCapture(event.pointerId)) {
              viewport.setPointerCapture(event.pointerId);
            }
          }
        }

        if (!sliderDragState.moved) return;

        event.preventDefault();

        if (ENABLE_TABS_SLIDER_AUTOSCROLL) {
          var loopWidth = getSliderLoopWidth(rail);
          if (!loopWidth) return;
          sliderAutoplayState.offset = normalizeMarqueeOffset(sliderDragState.startOffset - deltaX, loopWidth);
        } else {
          var maxOffset = getStaticMaxOffset(rail, viewport);
          sliderAutoplayState.offset = Math.max(0, Math.min(sliderDragState.startOffset - deltaX, maxOffset));
        }

        applyMarqueeOffset(rail, sliderAutoplayState.offset);
      });

      viewport.addEventListener('pointerup', function (event) {
        if (event.pointerId !== sliderDragState.pointerId) return;

        if (!sliderDragState.moved) {
          sliderDragState.suppressClick = false;
        }

        if (viewport.hasPointerCapture(event.pointerId)) {
          viewport.releasePointerCapture(event.pointerId);
        }
        if (sliderDragState.moved && shouldResumeDesktopAutoplay(viewport, rail)) {
          sliderAutoplayState.paused = false;
          sliderAutoplayState.lastTimestamp = 0;
        }
        resetDragState();
      });

      viewport.addEventListener('pointercancel', function (event) {
        if (event.pointerId !== sliderDragState.pointerId) return;

        if (viewport.hasPointerCapture(event.pointerId)) {
          viewport.releasePointerCapture(event.pointerId);
        }
        if (sliderDragState.moved && shouldResumeDesktopAutoplay(viewport, rail)) {
          sliderAutoplayState.paused = false;
          sliderAutoplayState.lastTimestamp = 0;
        }
        resetDragState();
      });

      viewport.addEventListener('click', function (event) {
        if (!sliderDragState.suppressClick) return;

        event.preventDefault();
        event.stopPropagation();
        sliderDragState.suppressClick = false;
      }, true);
    }

    function getCollectionInstance() {
      if (typeof theme === 'undefined' || !theme.sections) return null;
      var instances = theme.sections.instances || [];
      for (var i = 0; i < instances.length; i++) {
        if (instances[i].type === 'collection-grid') return instances[i];
      }
      return null;
    }

    function syncCategoryTabs() {
      var params = new URLSearchParams(window.location.search);
      var activeValue = params.get(SLIDER_PARAM) || '';
      document.querySelectorAll('.js-category-tab').forEach(function (btn) {
        var matches = btn.dataset.filterValue === activeValue;
        btn.classList.toggle('is-active', matches);
        btn.setAttribute('aria-pressed', String(matches));
      });
      
    }

    function getCollectionSectionId() {
      var container = document.querySelector('[data-section-type="collection-grid"]');
      return container ? container.getAttribute('data-section-id') : '';
    }

    function getTabImageNodesForValue(filterValue) {
      if (!filterValue) return [];

      return Array.prototype.slice.call(
        document.querySelectorAll('.js-category-tab[data-filter-value="' + CSS.escape(filterValue) + '"]')
      );
    }

    function normalizeTabImageSrc(src) {
      if (!src) return '';

      var normalizedSrc = src.trim();
      if (!normalizedSrc) return '';

      normalizedSrc = normalizedSrc.replace(/(_\d+x\d+)(?=\.(jpg|jpeg|png|webp|gif|avif|bmp|tiff)(\?|$))/i, '');

      try {
        var resolvedUrl = new URL(normalizedSrc, window.location.origin);
        resolvedUrl.searchParams.set('width', '420');
        resolvedUrl.searchParams.set('height', '596');
        resolvedUrl.searchParams.set('crop', 'center');
        return resolvedUrl.toString();
      } catch (error) {
        return normalizedSrc;
      }
    }

    function createTabImageElement(src, altText) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = altText || '';
      img.loading = 'lazy';
      img.width = 105;
      img.height = 149;
      return img;
    }

    function applyTabImageToValue(filterValue, src) {
      if (!filterValue || !src) return;

      tabImageUrlCache[filterValue] = src;

      getTabImageNodesForValue(filterValue).forEach(function (tab) {
        var imgWrap = tab.querySelector('.category-tab__img-wrap');
        if (!imgWrap || imgWrap.querySelector('img')) return;

        var label = tab.querySelector('.category-tab__label');
        var altText = label ? label.textContent.trim() : '';
        var img = createTabImageElement(src, altText);
        var bar = imgWrap.querySelector('.category-tab__bar');

        if (bar) {
          imgWrap.insertBefore(img, bar);
        } else {
          imgWrap.prepend(img);
        }
      });
    }

    function extractTabImageFromSectionHtml(htmlText) {
      if (!htmlText) return '';

      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlText, 'text/html');
      var productImg = doc.querySelector(
        '#CollectionAjaxContent .grid-product__image-mask img, ' +
        '#CollectionAjaxContent .grid__item-image-wrapper img, ' +
        '#CollectionAjaxContent .image-wrap img'
      );

      if (!productImg) return '';

      return normalizeTabImageSrc(
        productImg.getAttribute('src') ||
        productImg.getAttribute('data-src') ||
        ''
      );
    }

    function fetchTabImageForValue(filterValue) {
      if (!filterValue || !SLIDER_PARAM) {
        return Promise.resolve('');
      }

      if (tabImageUrlCache[filterValue]) {
        return Promise.resolve(tabImageUrlCache[filterValue]);
      }

      if (tabImageRequestCache[filterValue]) {
        return tabImageRequestCache[filterValue];
      }

      var sectionId = getCollectionSectionId();
      if (!sectionId) {
        return Promise.resolve('');
      }

      var requestUrl = new URL(window.location.pathname, window.location.origin);
      requestUrl.searchParams.set('section_id', sectionId);
      requestUrl.searchParams.set(SLIDER_PARAM, filterValue);

      tabImageRequestCache[filterValue] = fetch(requestUrl.toString())
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (htmlText) {
          var imageSrc = extractTabImageFromSectionHtml(htmlText);
          if (imageSrc) {
            tabImageUrlCache[filterValue] = imageSrc;
          }
          return imageSrc;
        })
        .catch(function () {
          return '';
        })
        .finally(function () {
          delete tabImageRequestCache[filterValue];
        });

      return tabImageRequestCache[filterValue];
    }

    /**
     * For tabs without a Liquid-rendered image, fetch the filtered collection
     * via Section Rendering API and grab the first product image.
     * Works on both production (product_type filter) and staging (taxonomy filter).
     */
    function loadMissingTabImages() {
      if (!SLIDER_PARAM) return;
      var tabs = document.querySelectorAll('.js-category-tab[data-filter-value]');
      var missingValues = [];

      tabs.forEach(function (tab) {
        var filterValue = tab.dataset.filterValue;
        if (!filterValue) return;

        var imgWrap = tab.querySelector('.category-tab__img-wrap');
        if (!imgWrap || imgWrap.querySelector('img')) return;

        if (tabImageUrlCache[filterValue]) {
          applyTabImageToValue(filterValue, tabImageUrlCache[filterValue]);
          return;
        }

        if (missingValues.indexOf(filterValue) === -1) {
          missingValues.push(filterValue);
        }
      });

      missingValues.forEach(function (filterValue) {
        fetchTabImageForValue(filterValue).then(function (src) {
          if (!src) return;
          applyTabImageToValue(filterValue, src);
        });
      });
    }

    function bindTrackDragInteractions() {
      var track = document.querySelector('.category-slider__track');
      if (!track || track.dataset.trackDragBound === 'true') return;
      track.dataset.trackDragBound = 'true';

      var isDragging = false;
      var pointerId = null;
      var startX = 0;
      var startScrollLeft = 0;
      var hasMoved = false;
      var DRAG_ACTIVATION_DISTANCE = 12;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        isDragging = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        hasMoved = false;
      });

      track.addEventListener('pointermove', function (event) {
        if (!isDragging || event.pointerId !== pointerId) return;
        var deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > DRAG_ACTIVATION_DISTANCE) {
          if (!hasMoved) {
            hasMoved = true;
            track.setPointerCapture(event.pointerId);
            track.classList.add('is-track-dragging');
          }
          event.preventDefault();
          track.scrollLeft = startScrollLeft - deltaX;
        }
      });

      function endDrag(event) {
        if (!isDragging || event.pointerId !== pointerId) return;
        isDragging = false;
        pointerId = null;
        track.classList.remove('is-track-dragging');
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', function (event) {
        if (hasMoved) {
          event.preventDefault();
          event.stopPropagation();
          hasMoved = false;
        }
      }, true);
    }

    function bindSliderArrowInteractions() {
      var elements = getCategorySliderElements();
      if (!elements) return;

      var slider = elements.slider;
      var viewport = elements.viewport;
      var rail = elements.rail;
      var nav = slider.querySelector('[data-cs-nav-desktop]');

      if (!nav || !viewport || !rail) return;

      var prevBtn = nav.querySelector('[data-cs-prev-desktop]');
      var nextBtn = nav.querySelector('[data-cs-next-desktop]');
      if (!prevBtn || !nextBtn) return;

      function getDesktopStepMetrics() {
        var tabs = Array.prototype.slice.call(rail.querySelectorAll('.category-tab'));
        var firstTab = tabs[0];

        if (!firstTab) {
          return {
            tabs: tabs,
            gap: 0,
            tabWidth: viewport.clientWidth,
            cardsPerStep: 1,
            step: viewport.clientWidth
          };
        }

        var styles = window.getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap || 0);
        if (!Number.isFinite(gap)) {
          gap = 0;
        }

        var tabWidth = firstTab.getBoundingClientRect().width;
        var cardsPerStep = Math.max(1, Math.floor((viewport.clientWidth + gap) / (tabWidth + gap)));

        return {
          tabs: tabs,
          gap: gap,
          tabWidth: tabWidth,
          cardsPerStep: cardsPerStep,
          step: (tabWidth + gap) * cardsPerStep
        };
      }

      function getCardAlignedScrollTarget(direction) {
        var metrics = getDesktopStepMetrics();
        var maxScrollLeft = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        var currentScrollLeft = viewport.scrollLeft;
        var tolerance = 2;

        if (maxScrollLeft <= 0) return 0;

        if (direction > 0 && maxScrollLeft - currentScrollLeft <= metrics.step + tolerance) {
          return maxScrollLeft;
        }

        if (direction < 0 && currentScrollLeft <= metrics.step + tolerance) {
          return 0;
        }

        return Math.max(0, Math.min(currentScrollLeft + (direction * metrics.step), maxScrollLeft));
      }

      function isEdgeTabFullyVisible(direction) {
        var tabs = rail.querySelectorAll('.category-tab');
        if (!tabs.length) return true;

        var visibilityTolerance = 4;
        var viewportRect = viewport.getBoundingClientRect();
        var edgeTab = direction < 0 ? tabs[0] : tabs[tabs.length - 1];
        var edgeRect = edgeTab.getBoundingClientRect();

        if (direction < 0) {
          return edgeRect.left >= viewportRect.left - visibilityTolerance;
        }

        return edgeRect.right <= viewportRect.right + visibilityTolerance;
      }

      function updateArrows() {
        if (!isDesktopViewport()) {
          nav.classList.remove('is-active');
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          return;
        }

        var maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
        var currentScrollLeft = viewport.scrollLeft;
        var hasOverflow = maxScrollLeft > 1;
        var isAtStart = currentScrollLeft <= 2 || isEdgeTabFullyVisible(-1);
        var isAtEnd = maxScrollLeft <= 0 || currentScrollLeft >= maxScrollLeft - 2 || isEdgeTabFullyVisible(1);

        nav.classList.toggle('is-active', hasOverflow);

        if (!hasOverflow) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          return;
        }

        prevBtn.disabled = isAtStart;
        nextBtn.disabled = isAtEnd;
      }

      // Always refresh state on subsequent calls (AJAX reload, etc.)
      if (nav.dataset.csBound === 'true') {
        requestAnimationFrame(function () {
          requestAnimationFrame(updateArrows);
        });
        return;
      }
      nav.dataset.csBound = 'true';

      prevBtn.addEventListener('click', function () {
        viewport.scrollTo({ left: getCardAlignedScrollTarget(-1), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        viewport.scrollTo({ left: getCardAlignedScrollTarget(1), behavior: 'smooth' });
      });

      viewport.addEventListener('scroll', updateArrows, { passive: true });
      slider.addEventListener('category-slider:layout-updated', updateArrows);
      window.addEventListener('resize', updateArrows);

      requestAnimationFrame(function () {
        requestAnimationFrame(updateArrows);
      });
    }

    function initCategorySlider() {
      var slider = document.querySelector('[data-category-slider]');

      syncCategoryTabs();
      scheduleSliderAutoplayRefresh();
      loadMissingTabImages();
      bindTrackDragInteractions();
      bindSliderAutoplayInteractions();
      bindSliderDragInteractions();
      bindSliderArrowInteractions();

      if (slider) {
        slider.addEventListener('click', function (e) {
          var tab = e.target.closest('.js-category-tab');
          if (!tab) return;

          var currentActiveValue = getActiveSliderFilterValue();

          // If the clicked filter is the current active filter, deselect it (reset to All Products)
          var filterValue = currentActiveValue === tab.dataset.filterValue && tab.dataset.filterValue !== ''
            ? ''
            : tab.dataset.filterValue;
          var params = new URLSearchParams(window.location.search);

          var keysToDelete = [];
          params.forEach(function (_, key) {
            if (key.indexOf('filter.') === 0) keysToDelete.push(key);
          });
          keysToDelete.forEach(function (key) { params.delete(key); });

          if (filterValue !== '') {
            params.set(SLIDER_PARAM, filterValue);
          }
          params.delete('page');

          // Optimistically mark the clicked tab active before AJAX completes
          document.querySelectorAll('.js-category-tab').forEach(function (t) {
            var isActive = t.dataset.filterValue === filterValue;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-pressed', String(isActive));
          });

          var collectionInstance = getCollectionInstance();
          if (!collectionInstance) {
            var newSearch = params.toString() ? '?' + params.toString() : '';
            window.location.assign(window.location.pathname + newSearch);
            return;
          }

          var nextSearch = params.toString() ? '?' + params.toString() : '';
          history.pushState({}, '', window.location.pathname + nextSearch);

          // Prevent the scroll-to-grid jump after tab click
          pinScrollForNextReload(collectionInstance);

          // Restore column layouts after AJAX — server HTML always resets defaults
          var colsBefore = sessionStorage.getItem('impulse_grid_cols') || '2';
          var desktopColsBefore = sessionStorage.getItem('impulse_grid_cols_desktop') || '5';
          document.addEventListener('collection:reloaded', function onSliderReloaded() {
            document.removeEventListener('collection:reloaded', onSliderReloaded);
            var wrapper = document.querySelector('.collection-grid__wrapper');
            if (wrapper) {
              // Restore mobile
              document.querySelectorAll('.js-grid-col-btn').forEach(function (b) {
                var active = b.getAttribute('data-columns') === colsBefore;
                b.classList.toggle('is-active', active);
                b.setAttribute('aria-pressed', String(active));
              });
              wrapper.setAttribute('data-mobile-columns', colsBefore);
              // Restore desktop
              document.querySelectorAll('.js-grid-col-btn-desktop').forEach(function (b) {
                var active = b.getAttribute('data-columns') === desktopColsBefore;
                b.classList.toggle('is-active', active);
                b.setAttribute('aria-pressed', String(active));
              });
              wrapper.setAttribute('data-desktop-columns', desktopColsBefore);
            }
          });

          collectionInstance.startLoading();
          collectionInstance.renderCollectionPage(params, false);
        });
      }

      // Document/window listeners bound once — initCategorySlider re-runs
      // on theme-editor section reloads, and rebinding these would stack.
      if (!window.__categorySliderDocBound) {
        window.__categorySliderDocBound = true;
        document.addEventListener('collection:reloaded', syncCategoryTabs);
        document.addEventListener('collection:reloaded', function () {
          scheduleSliderAutoplayRefresh();
          loadMissingTabImages();
          bindTrackDragInteractions();
          bindSliderAutoplayInteractions();
          bindSliderDragInteractions();
          bindSliderArrowInteractions();
          // Deferred AOS refresh — ensures product cards animate in after DOM settles
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              if (window.AOS) { AOS.refreshHard(); }
            });
          });
        });
        window.addEventListener('resize', function () {
          clearTimeout(sliderResizeTimer);
          sliderResizeTimer = setTimeout(function () {
            scheduleSliderAutoplayRefresh();
          }, SLIDER_RESIZE_DEBOUNCE);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCategorySlider);
    } else {
      initCategorySlider();
    }

    // Theme editor: section markup is re-rendered on setting changes; the
    // inline scripts this file replaced used to re-execute then. Fresh
    // elements carry no dataset guards, so re-init rebinds them cleanly.
    document.addEventListener('shopify:section:load', initCategorySlider);
  })();

  /* Grid column toggle JS and product count JS moved to collection-grid.liquid */

  /* Collection redesign: sidebar hide/show toggle + colour facet opener */
  (function () {
    var KEY = 'dfyne_sidebar_hidden';
    // Set when the colour click that triggered the AJAX apply came from
    // INSIDE the overflow popover — that apply's collection:reloaded skips
    // closeAllColourPopovers so the popover stays open and the shopper can
    // keep ticking colours (Andrew). Cleared on the next reload.
    var keepColourPopoverOpen = false;
    function applySidebarState() {
      var root = document.querySelector('.collection-content');
      if (!root) return;
      root.classList.toggle('is-sidebar-hidden', sessionStorage.getItem(KEY) === '1');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-hide-filters')) {
        sessionStorage.setItem(KEY, '1');
        applySidebarState();
      } else if (e.target.closest('.js-show-filters')) {
        sessionStorage.setItem(KEY, '0');
        applySidebarState();
      } else if (e.target.closest('.js-colour-dot')) {
        var dot = e.target.closest('.js-colour-dot');
        keepColourPopoverOpen = !!dot.closest('[data-colour-popover]');
        var params = new URLSearchParams(window.location.search);
        var pName = dot.dataset.param;
        var pValue = dot.dataset.value;
        // Optimistic ring: toggle the selected state NOW so the grow+ring
        // animation plays on the click (prototype behavior) instead of
        // seconds later when the AJAX render lands. syncColourDots
        // reconciles from the URL after the reload, including the
        // row/popover swap.
        var willBeActive = !dot.classList.contains('is-active');
        dot.classList.toggle('is-active', willBeActive);
        dot.setAttribute('aria-pressed', String(willBeActive));
        var values = params.getAll(pName);
        params.delete(pName);
        var removed = false;
        values.forEach(function (v) {
          if (v === pValue) { removed = true; return; }
          params.append(pName, v);
        });
        if (!removed) params.append(pName, pValue);
        params.delete('page');
        // AJAX apply, scroll pinned (Andrew: the page must not move when
        // selecting a colour) — the old window.location.assign() full
        // reload reset/jumped the scroll position. Same pattern as the
        // category-tab click handler. Falls back to a reload if the
        // collection instance isn't up yet.
        var inst = (window.theme && theme.sections && theme.sections.instances || []).find(function (i) { return i.type === 'collection-grid'; });
        var search = params.toString();
        if (!inst) {
          window.location.assign(window.location.pathname + (search ? '?' + search : ''));
          return;
        }
        history.pushState({}, '', window.location.pathname + (search ? '?' + search : ''));
        pinScrollForNextReload(inst);
        inst.startLoading();
        inst.renderCollectionPage(params, false);
      } else if (e.target.closest('.js-open-colour-facet')) {
        var moreBtn = e.target.closest('.js-open-colour-facet');
        var existing = document.getElementById(moreBtn.getAttribute('aria-controls'));
        var willOpen = existing && existing.hasAttribute('hidden');
        closeAllColourPopovers();
        if (willOpen) openColourPopoverFor(moreBtn);
      } else if (!e.target.closest('[data-colour-popover]')) {
        closeAllColourPopovers();
      }
    });
    function openColourPopoverFor(moreBtn) {
      var popover = document.getElementById(moreBtn.getAttribute('aria-controls'));
      if (!popover) return;
      /* Portal to <body> with position:absolute (document-relative, not
         viewport-relative) so it moves naturally with the page on ANY
         scroll/shift — including horizontal trackpad rubber-banding —
         instead of needing to detect and react to every gesture. This
         also escapes .category-slider's overflow:hidden (needed for the
         tab-bar's horizontal scroll clipping), which would otherwise
         clip the popover regardless of z-index. */
      document.body.appendChild(popover);
      popover.removeAttribute('hidden');
      var btnRect = moreBtn.getBoundingClientRect();
      var popRect = popover.getBoundingClientRect();
      popover.style.top = (btnRect.bottom + window.scrollY + 12) + 'px';
      popover.style.left = (btnRect.right + window.scrollX - popRect.width) + 'px';
      moreBtn.setAttribute('aria-expanded', 'true');
      // WCAG 2.4.3 (T7 audit): the portal moves the popover to the end of
      // the document, breaking tab order from the trigger — move focus into
      // it on open; closeAllColourPopovers returns focus to the trigger.
      popover.__returnFocusTo = moreBtn;
      var firstDot = popover.querySelector('.js-colour-dot');
      if (firstDot) firstDot.focus();
    }
    function closeAllColourPopovers() {
      document.querySelectorAll('[data-colour-popover]').forEach(function (p) {
        var hadFocus = p.contains(document.activeElement);
        p.setAttribute('hidden', '');
        var btn = document.querySelector('[aria-controls="' + p.id + '"]');
        if (btn) {
          btn.setAttribute('aria-expanded', 'false');
          // return focus to the trigger so keyboard users aren't dropped at
          // the end of the document when the portaled popover hides
          if (hadFocus || (p.__returnFocusTo && p.__returnFocusTo.contains(document.activeElement))) {
            (p.__returnFocusTo || btn).focus();
          }
        }
        p.__returnFocusTo = null;
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllColourPopovers();
    });

    /* Colour dots live OUTSIDE #CollectionAjaxContent (they survive AJAX
       swaps), so after an AJAX apply their state is synced here instead of
       re-rendered: is-active from the URL, and active overflow colours are
       PROMOTED out of the popover to the end of the visible row (demoted
       back when unticked). Liquid renders the same promoted state
       server-side (data-promoted) for full loads. */
    function syncColourDots() {
      var params = new URLSearchParams(window.location.search);
      document.querySelectorAll('.js-colour-dot').forEach(function (d) {
        if (!d.dataset.param) return;
        var active = params.getAll(d.dataset.param).indexOf(d.dataset.value) !== -1;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-pressed', String(active));
      });
      // Row composition (Andrew): ALWAYS exactly 5 dots. Selected overflow
      // colours take the rightmost slots as promoted COPIES (the originals
      // stay in the popover, ringed); the displaced originals swap into
      // the popover. Reset-then-apply so full-load Liquid state and AJAX
      // resyncs converge on the same layout.
      document.querySelectorAll('[data-colour-dots]').forEach(function (row) {
        var moreWrap = row.querySelector('.colour-dots-more-wrap');
        if (!moreWrap) return;
        var moreBtn = moreWrap.querySelector('.js-open-colour-facet');
        var popover = moreBtn && document.getElementById(moreBtn.getAttribute('aria-controls'));
        if (!popover) return;
        // RESET: send promoted dots home to the popover (they are MOVED,
        // not copied — a colour never appears in the row and the modal at
        // once); bring displaced originals home, in order
        row.querySelectorAll(':scope > .js-colour-dot[data-promoted]').forEach(function (d) {
          delete d.dataset.promoted;
          popover.appendChild(d);
        });
        var originals = Array.prototype.slice.call(row.querySelectorAll(':scope > .js-colour-dot[data-row-index]'))
          .concat(Array.prototype.slice.call(popover.querySelectorAll('.js-colour-dot[data-row-index]')));
        originals.sort(function (a, b) { return (+a.dataset.rowIndex) - (+b.dataset.rowIndex); });
        originals.forEach(function (d) { row.insertBefore(d, moreWrap); });
        // APPLY: selected overflow colours take rightmost slots, but an
        // ACTIVE original is never swapped out (Andrew) — only the
        // rightmost NON-active originals are displaced, and the promoted
        // count is capped by how many of those exist.
        var activeOverflow = Array.prototype.slice.call(
          popover.querySelectorAll('.js-colour-dot.is-active:not([data-row-index])')
        );
        var inactiveOriginals = originals.filter(function (d) { return !d.classList.contains('is-active'); });
        var k = Math.min(activeOverflow.length, inactiveOriginals.length);
        if (!k) return;
        // swap the rightmost k NON-active originals into the popover...
        inactiveOriginals.slice(inactiveOriginals.length - k).forEach(function (d) {
          popover.appendChild(d);
        });
        // ...and MOVE the selected overflow dots into the row's rightmost
        // slots (true swap — the dot leaves the modal)
        activeOverflow.slice(0, k).forEach(function (d) {
          d.dataset.promoted = 'true';
          row.insertBefore(d, moreWrap);
        });
      });
    }

    /* Desktop sidebar facet triggers show "(n)" for applied values. The
       sidebar DOM persists across AJAX applies, so the server-rendered
       count (Liquid) is kept live here from the URL. */
    function updateSidebarFacetCounts() {
      // #FilterDrawer included explicitly: the drawer gets portaled to
      // <body> during persist, leaving #CollectionSidebar (querySelectorAll
      // returns unique elements, so the nested case isn't double-counted).
      var params = new URLSearchParams(window.location.search);
      document.querySelectorAll('#CollectionSidebar [data-filter-param], #FilterDrawer [data-filter-param]').forEach(function (group) {
        if (group.classList.contains('js-availability-toggle-group')) return;
        var trigger = group.querySelector('.collapsible-trigger');
        if (!trigger) return;
        var n = params.getAll(group.getAttribute('data-filter-param')).length;
        var span = trigger.querySelector('.collapsible-trigger__count');
        if (n > 0) {
          if (!span) {
            span = document.createElement('span');
            span.className = 'collapsible-trigger__count';
            trigger.insertBefore(span, trigger.querySelector('.collapsible-trigger__icon'));
          }
          span.textContent = ' (' + n + ')';
        } else if (span) {
          span.remove();
        }
      });
    }

    applySidebarState();
    populateFilterDrawer();
    syncColourDots();
    updateSidebarFacetCounts();
    document.addEventListener('collection:reloaded', function () {
      applySidebarState();
      populateFilterDrawer();
      // A colour ticked inside the popover keeps it open across the AJAX
      // apply so more colours can be added seamlessly; any other reload
      // (tab click, sidebar filter, row dot) still closes it.
      if (keepColourPopoverOpen) {
        keepColourPopoverOpen = false;
      } else {
        closeAllColourPopovers();
      }
      syncColourDots();
      updateSidebarFacetCounts();
    });
    document.addEventListener('shopify:section:load', function () {
      applySidebarState();
      populateFilterDrawer();
    });
  })();

  /* Tab bar stuck detection — toggles .is-stuck, which turns on the white
     box-shadow cover above the bar (collection-redesign-styles). Compares
     the bar's viewport top to its sticky offset; the slider element lives
     outside #CollectionAjaxContent so it survives AJAX swaps. */
  (function () {
    var ticking = false;
    function update() {
      ticking = false;
      var slider = document.querySelector('[data-category-slider]');
      if (!slider) return;
      var stickyTop = parseFloat(slider.style.top || window.getComputedStyle(slider).top) || 0;
      slider.classList.toggle('is-stuck', slider.getBoundingClientRect().top <= stickyTop + 1);
    }
    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    // First sync inside a frame — a synchronous getBoundingClientRect here
    // forced a mid-parse layout of everything above (the whole grid).
    requestAnimationFrame(update);
  })();

  /* ── Hover (secondary) card image: fetch on first hover, not on scroll ──
     new-product-card.liquid wraps .grid-product__secondary-image in an inert
     <template data-secondary-image> so the browser never requests it during
     load/scroll. First mouseover on a card stamps the real markup in; the
     CSS hover fade then reveals it once loaded. Desktop-only by nature
     (mouseover), which matches the wrapper's small--hide. data-aos is
     stripped from the clone — AOS never processes late-added nodes, and the
     theme's [data-aos] boot rule would hold the image at opacity 0 forever. */
  (function () {
    document.addEventListener('mouseover', function (e) {
      if (!e.target || !e.target.closest) return;
      var card = e.target.closest('.grid-product');
      if (!card || card.dataset.secondaryImageLoaded === 'true') return;
      card.dataset.secondaryImageLoaded = 'true';
      var tpl = card.querySelector('template[data-secondary-image]');
      if (!tpl) return;
      var frag = tpl.content.cloneNode(true);
      frag.querySelectorAll('[data-aos]').forEach(function (el) {
        el.removeAttribute('data-aos');
      });
      tpl.parentNode.replaceChild(frag, tpl);
    });
  })();
